import { gql } from '@apollo/client'
import { POINT_FRAGMENT } from './PointFragment'

export const BOUNDING_CUBE_FRAGMENT = gql`
  fragment BoundingCube on BoundingCube {
    x1 {
      ...Point
    }
    x2 {
      ...Point
    }
    y1 {
      ...Point
    }
    z1 {
      ...Point
    }
    width
    height
    depth
  }
  ${POINT_FRAGMENT}
`
